export default __webpack_public_path__ + "static/media/120_sporofungus.d64c3ff5.webp";